var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}]},[_c('spin-loader')],1),_c('div',[_c('history-list',{attrs:{"history-list":_vm.historyList,"labels":_vm.labelList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }